import Post from "../Post/Post";
import Viewpost from "../ViewPost/Viewpost";

const Timelineflow = ({
  mybusinessType,
  shareTimeline,
  setShareTimeline,
  sharedToOtherTimeline,
  getbusinesstype,
  post_ID,
  getTimelinePosts,
  id,
  rightSide,
  getmyTimeline,
  mysetting,
  timelineid,
  data,
  CreatePostSubmit,
  setCreatePost,
  createPost,
  show,
  setShow,
  setGetmyTimeline,
  timelineLoading,
  onShareSuccess,
}) => {
  return (
    <>
      <div className="d-flex align-items-center flex-column">
        {Number(rightSide) >= 10 ? (
          <Viewpost
            mybusinessType={mybusinessType}
            shareTimeline={shareTimeline}
            sharedToOtherTimeline={sharedToOtherTimeline}
            getbusinesstype={getbusinesstype}
            post_ID={post_ID}
            id={id}
            rightSide={rightSide}
            setShareTimeline={setShareTimeline}
            setGetmyTimeline={setGetmyTimeline}
            mysetting={mysetting}
            getTimelinePosts={getTimelinePosts}
            timelineid={timelineid}
            data={data}
            createPost={createPost}
            getmyTimeline={getmyTimeline}
            timelineLoading={timelineLoading}
            onShareSuccess={onShareSuccess}
          />
        ) : (
          <>
            <Post
              id={id}
              mybusinessType={mybusinessType}
              mysetting={mysetting}
              data={data}
              CreatePostSubmit={CreatePostSubmit}
              setCreatePost={setCreatePost}
              createPost={createPost}
              show={show}
              setShow={setShow}
            />
            <Viewpost
              mybusinessType={mybusinessType}
              shareTimeline={shareTimeline}
              sharedToOtherTimeline={sharedToOtherTimeline}
              getbusinesstype={getbusinesstype}
              post_ID={post_ID}
              id={id}
              mysetting={mysetting}
              setShareTimeline={setShareTimeline}
              setGetmyTimeline={setGetmyTimeline}
              getTimelinePosts={getTimelinePosts}
              timelineid={timelineid}
              data={data}
              createPost={createPost}
              getmyTimeline={getmyTimeline}
              timelineLoading={timelineLoading}
              onShareSuccess={onShareSuccess}
            />
          </>
        )}
      </div>
    </>
  );
};

export default Timelineflow;
